import { useEffect } from "react";
import PageHero from "@/components/common/PageHero";
import { manufacturingSteps } from "@/data/siteContent";
import manufacturing from "@/assets/images/manufacturing.png";

const ManufacturingPage = () => {
  useEffect(() => {
    document.title = "Manufacturing Process | Keshavlal & Company";
  }, []);

  return (
    <div data-testid="manufacturing-page-root">
      <PageHero
        eyebrow="Manufacturing"
        title="From Fabric to Dispatch: Controlled Production Workflow"
        description="A streamlined process designed for quality consistency and dependable bulk delivery timelines."
        testId="manufacturing-page-hero"
      />

      <section className="bg-white" data-testid="manufacturing-timeline-section">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
          <div className="grid gap-5 lg:grid-cols-6" data-testid="manufacturing-timeline-grid">
            {manufacturingSteps.map((step, index) => (
              <article
                key={step.slug}
                className="relative rounded-2xl border border-slate-200 bg-slate-50 p-5"
                data-testid={`manufacturing-timeline-card-${step.slug}`}
              >
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-orange-600" data-testid={`manufacturing-step-number-${step.slug}`}>
                  Step {index + 1}
                </p>
                <h2 className="mt-2 text-lg font-semibold text-slate-900" data-testid={`manufacturing-step-title-${step.slug}`}>
                  {step.title}
                </h2>
                <p className="mt-2 text-sm text-slate-600" data-testid={`manufacturing-step-detail-${step.slug}`}>
                  {step.detail}
                </p>
              </article>
            ))}
          </div>

          <div className="mt-10 overflow-hidden rounded-3xl border border-slate-200 bg-slate-50" data-testid="manufacturing-factory-image-wrapper">
            <img
              src={manufacturing}
              alt="Umbrella production line"
              className="h-[560px] w-full object-contain object-center p-4 md:h-[760px]"
              data-testid="manufacturing-factory-image"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManufacturingPage;